<template>
    <Disclosure as="div" :key="league.id" v-slot="{ open }">
        <dt class="text-lg sm:border-0" :class="[open ? 'border-t-gray-400 border-t' : 'sm:pb-1 border-t border-t-gray-500 border-b-gray-800 border-b']">
            <DisclosureButton class="text-left w-full justify-between items-start text-gray-400 p-4 transition ease-in-out" :class="[open ? 'sm:rounded-t bg-gray-500' : 'sm:rounded bg-gradient-to-r from-gray-800 to-gray-500']" @click="getLeaderboard(league.id, open)">
                <span class="flex items-center justify-center">
                    <span class="font-medium text-white capitalize text-sm md:text-lg grow flex">
                        <span>{{ league.name }}</span>
                    </span>
                    <span class="flex ml-6 h-7 grow items-center justify-end">
                        <ChevronDownIcon class="text-gray-800" :class="[open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform']" aria-hidden="true" />
                    </span>
                </span>
                <span class="flex mt-2" v-if="leaderboard.length">
                    <span class="text-white capitalize text-xs flex mr-2">
                        <span>Your Position: {{ getUser().position }}</span>
                    </span>
                    <span class="text-white capitalize text-xs flex mr-2">
                        Players: {{ leaderboard.length }}
                    </span>
                </span>
            </DisclosureButton>
        </dt>

        <DisclosurePanel as="dd" class="p-4 bg-gray-500 sm:border-0" :class="{ 'border-b-gray-600 border-b mb-1 rounded-b': open }">
            <div :class="highlightUser(result)" class="text-white flex bg-gradient-to-r from-gray-800 to-gray-500 p-2 rounded shadow-md mb-2 items-center text-center" v-for="result in leaderboard" >
            	<div class="flex mr-2">{{ result.position }}</div>
            	<div class="shrink-0 h-10 w-10 mr-2">
                    <img class="rounded-full h-10 w-10 object-cover" :src="result.profile_photo_url" />
                </div>
            	<div class="flex grow">{{ result.username }}</div>
            	<div class="flex uppercase">{{ result.points }} Points</div>
            </div>

            <div class="flex mt-4 justify-end">
            	<button class="bg-gray-900 rounded py-2 px-4 flex items-center" @click="shareLeagueState = true"><ShareIcon class="w-4 text-white mr-2" />Share</button>
            </div>
        </DisclosurePanel>
    </Disclosure>

    <tw-modal :show="shareLeagueState" @close="shareLeagueState = false" title="Share Your League" subtitle="Share your league with your friends and get competitive." :padding="true">
        <div class="p-4 mt-4 grid grid-cols-3 gap-4">
            <div class="col-span-1 cursor-pointer p-4">
                <WhatsappIcon @click="joinOnWhatsapp" />
            </div>
            <div class="col-span-1 cursor-pointer p-4">
                <FacebookIcon class="dark:text-racing-stars-yellow" @click="joinOnFacebook" />
            </div>
            <div class="col-span-1 cursor-pointer p-4">
                <TwitterIcon class="dark:text-racing-stars-yellow" @click="joinOnTwitter" />
            </div>
        </div>
        <div class="px-8 mt-2 mb-6 text-center">
            <span class="font-bold">Entry Code: </span>{{ league.code }}
        </div>
    </tw-modal>
</template>

<script>
	import { ref } from 'vue'
	import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
	import { ChevronDownIcon, ClockIcon, DatabaseIcon, UsersIcon, CheckIcon, ShareIcon } from '@heroicons/vue/outline'

	export default {
		props: {
			league: {
				type: Object,
				default: []
			},
			user: {
				type: Object,
				default: []
			}
		},
	    components: {
	        Disclosure,
	        DisclosureButton,
	        DisclosurePanel,
	        ChevronDownIcon,
	        ClockIcon,
	        DatabaseIcon,
	        UsersIcon,
	        CheckIcon,
	        ShareIcon,
	    },

		setup(props) {

			const leaderboard = ref([])
	        const shareLeagueState = ref(false)

	        const getLeaderboard = (leagueId, open) => {
	        	if (!open) {
		            axios.get(route('api.leaderboard.index'), {
		                    params: {
		                        league_id: leagueId
		                    }
		                })
		                .then(response => {
		                    leaderboard.value = response.data
		                })
		        } else {
		        	leaderboard.value = []
		        }
	        }

	        const getUser = () => {
	        	let user = {}

	            leaderboard.value.forEach(result => {
	            	if (result.id === props.user.id) {
	            		user = result
	            	}
	            })

	            return user
	        }

	        const highlightUser = (result) => {
	        	let border = ''

	            if (result.id === props.user.id) {
	            	border = 'border border-racing-stars-yellow'
	            }

	            return border
	        }

	        const joinOnWhatsapp = () => {
	            window.location = ('whatsapp://send?text=Join my league on Racing Stars' + ' ' + route('leagues.update', { code: props.league.code }))
	        }

	        const joinOnFacebook = () => {
	            openSharer('https://www.facebook.com/sharer/sharer.php?u=' + route('leagues.update', { code: props.league.code }) + '&t=Join my league on Racing Stars')
	        }

	        const joinOnTwitter = () => {
	            openSharer('https://twitter.com/share?url=' + route('leagues.update', { code: props.league.code }) + '&via=RacingStarsLtd&text=Join my league on Racing Stars')
	        }

	        const openSharer = (url) => {
	            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
	        }

	        return {
	        	leaderboard,
	        	getLeaderboard,
	        	getUser,
	        	highlightUser,
	            joinOnWhatsapp,
	            joinOnFacebook,
	            joinOnTwitter,
	            openSharer,
	            shareLeagueState,
	        }

		}
	}
</script>
